import React from 'react'

export default function Notfound() {
  return (
    <div className="container-fluid">
        <div className="row d-flex justify-content-center">
            <div className="col-md-4 text-center">
               <h1 className='blueColor pt-5 '> 404 Not Found </h1> 
            </div>
        </div>
    </div>
  )
}
